export default "__VITE_ASSET__f9Gd3s5z__"